import {MetafieldOverrides} from '../../types';
import type {
  OptionsOverrides,
  TranslatableResourceInformationOverrides,
} from '../types';

export function isMetafieldOverride(
  overrides?: TranslatableResourceInformationOverrides,
): overrides is MetafieldOverrides {
  const metafieldOverrides = overrides as MetafieldOverrides;
  return (
    metafieldOverrides?.type !== undefined &&
    Boolean(metafieldOverrides?.ownerType)
  );
}

export function isOptionsOverride(
  overrides?: TranslatableResourceInformationOverrides,
): overrides is OptionsOverrides {
  return (overrides as OptionsOverrides)?.position !== undefined;
}
